@use 'variables' as *;
@use 'mixins' as *;

@import '~flatpickr/dist/flatpickr.css';
@import '../styles/vendor/flatpickr';

:host {
  display: inline-flex;

  > div {
    display: flex;
  }
}

:host([hidden]) {
  display: none;
}

.datepicker-disabled,
.datepicker-readonly {
  .flatpickr-days,
  .flatpickr-time {
    pointer-events: none;
  }
}

.datepicker-disabled {
  .flatpickr-days {
    opacity: 0.75;
  }

  .flatpickr-time {
    input,
    .flatpickr-time-separator,
    .flatpickr-am-pm {
      color: cat-token('color.ui.font.muted');
      opacity: 0.75;
    }
  }
}

input {
  display: none;
}

.flatpickr-calendar {
  box-shadow: unset;
  background: unset;
}
